// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"YJrcE5tkrzjuFhv2E_22","button":"LENonm379LcKuj2otMa4"};